import React, { useState, useEffect, useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import MainContentLayout from '../../Layout/MainContentLayout'
import { formatCurrency } from '../../shared/utils'
import server from '../../../server'
import { AuthenticationContext } from '../../../Auth/authentication.context'
import useTableRowsPerPage from '../../../hooks/useTableRowsPerPage'
import { getInitialPaginationState } from '../../../shared/tablePagination'

export default function PaPayablesPharmacies() {
  const navigate = useNavigate()
  const { user } = useContext(AuthenticationContext)
  const { defaultRows, rowsPerPageOptions, applyPageEvent } = useTableRowsPerPage()
  const [pharmacies, setPharmacies] = useState([])
  const [loading, setLoading] = useState(true)
  const [pagination, setPagination] = useState(() =>
    getInitialPaginationState(user)
  )

  useEffect(() => {
    setPagination((prev) => ({ ...prev, rows: defaultRows }))
  }, [defaultRows])

  useEffect(() => {
    server
      .get('/admins/payables/pharmacies')
      .then((response) => {
        setPharmacies(response.data.data.pharmacies || [])
        setLoading(false)
      })
      .catch(() => setLoading(false))
  }, [])

  const totalConfirmedAmountBody = (row) =>
    formatCurrency(row.totalConfirmedAmount)
  const totalPaAmountDueBody = (row) => formatCurrency(row.totalPaAmountDue)

  return (
    <MainContentLayout title='PA Payables'>
      <DataTable
        value={pharmacies}
        loading={loading}
        dataKey='pharmacyId'
        selectionMode='single'
        onRowSelect={(e) =>
          navigate(`/admin/reports/paPayables/pharmacy/${e.data.pharmacyId}`)
        }
        rowHover
        showGridlines
        emptyMessage='No eligible pharmacies (Origins Management or in a group).'
        paginator
        rows={pagination.rows}
        first={pagination.first}
        onPage={(e) => setPagination((prev) => applyPageEvent(prev, e))}
        rowsPerPageOptions={rowsPerPageOptions}
      >
        <Column
          field='pharmacyName'
          header='Pharmacy Name'
          sortable
          body={(row) => row.pharmacyName || '-'}
        />
        <Column
          field='groupName'
          header='Group'
          sortable
          body={(row) => row.groupName || '-'}
        />
        <Column
          field='pendingOrderCount'
          header='Pending Orders (no PA paid)'
          sortable
        />
        <Column
          field='totalConfirmedAmount'
          header='Total Confirmed Amount'
          body={totalConfirmedAmountBody}
          sortable
        />
        <Column
          field='totalPaAmountDue'
          header='Total PA Amount Due'
          body={totalPaAmountDueBody}
          sortable
        />
      </DataTable>
    </MainContentLayout>
  )
}
